import { render, RootPart } from "lit/html.js";
import { getHtmlElementByClass } from "@utils/index";
import { SerpFiltersComponent } from ".";

export const renderSerpFiltersComponent = (): RootPart => render(SerpFiltersComponent(), getHtmlElementByClass('serp-filters'));